/**
 * Replaces a specific timezone name with a sibling timezone name.
 *
 * This function is a temporary fix to address the issue where some browsers
 * do not support the timezone `America/Ciudad_Juarez`. It replaces it with
 * the sibling timezone `America/Hermosillo`. If the input timezone name
 * does not match `America/Ciudad_Juarez`, it returns the original timezone name.
 *
 * @param {string} tzName - The name of the timezone to check and potentially replace.
 * @returns {string} - The original timezone name or the replacement timezone name.
 */
export function replaceToSiblingTimezoneName(tzName: string): string {
  // Replace 'America/Ciudad_Juarez' with 'America/Hermosillo' because some browsers do not support Ciudad_Juarez.
  // America/Hermosillo is a suitable replacement because it is the nearest timezone with the same GMT value and country.
  if (tzName === 'America/Ciudad_Juarez') {
    return 'America/Hermosillo';
  }
  // Return the original timezone name if no replacement is needed
  return tzName;
}
